<template>
  <div>
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script setup>
  //
import { ref, onMounted } from "vue";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);
const props = defineProps({ chartData: Object });
const chartCanvas = ref(null);

onMounted(() => {
  new Chart(chartCanvas.value, { type: "pie", data: props.chartData });
});
</script>
